import React, { PureComponent } from 'react'
import { array, modals } from 'helpers'
import { required } from 'helpers/validation'
import actions from 'redux/actions'
import reduxForm from 'local_modules/redux-form'
import cx from 'classnames'

import Button from 'components/ui/Button/Button'

import EditableFields from './EditableFields/EditableFields'

import s from './EditableTable.scss'


const getFormOptions = (props, newFieldsRows) => {
  const { fieldsRows } = props

  const rows          = newFieldsRows || fieldsRows
  const fields        = {}
  const initialValues = {}

  rows.forEach((fieldsRow, rowIndex) => {
    (fieldsRow.row || fieldsRow).forEach(({ fieldName, fieldType, value, validation }) => {
      if (fieldType !== 'text' && fieldType !== 'label' && fieldType !== 'box') {
        const index    = fieldsRow.id || rowIndex
        const fieldKey = `${fieldName}${index}`

        fields[fieldKey]        = [ validation ? validation(required, index) : required ]
        initialValues[fieldKey] = value >= 0 && !/object|boolean/.test(typeof value) ? `${value}` : value
      }
    })
  })

  return {
    name: 'editableTableForm',
    fields,
    initialValues: () => initialValues,
  }
}


class EditableTable extends PureComponent {

  state = {
    addedRows: [],
    removedRows: [],
  }

  componentDidMount() {
    const { setOnSubmit, submitForm } = this.props

    if (typeof setOnSubmit === 'function') {
      setOnSubmit(
        submitForm(this.getResult, this.handleSubmitError)
      )
    }
  }

  componentWillReceiveProps(props) {
    const { fieldsRows, updateFormOptions } = props
    const { fieldsRows: oldFieldsRows } = this.props

    const isFieldsChanged = (
      fieldsRows.length !== oldFieldsRows.length
      // || fieldsRows.some((fields, index) => (
      //   fields.some(({ value }, fieldIndex) => {
      //     return value !== oldFieldsRows[index][fieldIndex].value
      //   })
      // ))
    )

    if (isFieldsChanged) {
      this.setState({
        addedRows: [],
        removedRows: [],
      })

      updateFormOptions(
        getFormOptions(props)
      )
    }
  }

  getResult = (data) => {
    const { removedRows } = this.state
    const result = []

    Object.keys(data).forEach((key) => {
      const value     = data[key]
      const rowNumber = Number(key.replace(/\D+/g, '')) // Number(key[key.length - 1])
      const resultKey = key.replace(new RegExp(`${rowNumber}$`), '')

      if (!result[rowNumber]) {
        result[rowNumber] = {}
      }

      result[rowNumber][resultKey] = value
    })

    const maxRemoved  = Math.max(...removedRows) + 1
    const arrayLength = maxRemoved > result.length ? maxRemoved : result.length

    array.range(1, arrayLength).forEach((count, index) => {
      if (!result[index]) {
        result[index] = null
      }
    })

    return result
  }

  handleSubmit = (data) => {
    const { onSubmit } = this.props

    const result = this.getResult(data)

    onSubmit(result)
  }

  handleRemove = (removedRow) => {
    const { removedRows } = this.state
    const { updateFormOptions } = this.props

    actions.modals.open(modals.Dialog, {
      title: 'Удалить поле?',
      buttonTitle: 'Удалить',
      onButtonClick: () => {
        updateFormOptions(
          getFormOptions(
            this.props,
            this.getRows({
              removedRows: removedRows.concat([ removedRow ]),
            })
          )
        )

        this.setState({
          removedRows: removedRows.concat(removedRow),
        })
      },
    })
  }

  handleAdd = () => {
    const { addedRows } = this.state
    const { addRow, updateFormOptions } = this.props

    updateFormOptions(
      getFormOptions(
        this.props,
        this.getRows({
          addedRows: addedRows.concat([ addRow ]),
        })
      )
    )

    this.setState({
      addedRows: addedRows.concat([ addRow ]),
    })
  }

  getRows = ({ addedRows, removedRows } = {}) => {
    const { addedRows: _addedRows, removedRows: _removedRows } = this.state
    const { fieldsRows } = this.props

    return fieldsRows.concat(addedRows || _addedRows)
      .map((row, index) => ({ row, id: index }))
      .filter(({ row, id }) => !(removedRows || _removedRows).includes(id))
  }

  handleSubmitError = (errors) => console.error(errors)

  render() {
    const {
      rowClassName, buttonTitle, addButtonTitle, fields, columns, submitForm, removeSize, editSize, withButton = true, fieldValues, getRowClassName,
    } = this.props

    const rows = this.getRows()

    return (
      <div>
        {
          rows.map(({ row: fieldsRow, id }, index) => {
            const isRemovableRow = (
              fieldsRow[0].isRemovable
              || (
                typeof fieldsRow[0].checkIsRemovable === 'function'
                && fieldsRow[0].checkIsRemovable(rows.map(({ row }) => row))
              )
            )

            const updatedFieldsRow = fieldsRow.map((field) => {
              if (!fields[`${field.fieldName}${id}`]) {
                // console.log('no field for', `${field.fieldName}${id}`, {
                //   fields,
                //   state: this.state,
                //   rows,
                // })
              }

              return {
                ...field,
                valueLink: fields[`${field.fieldName}${id}`],
              }
            })

            return (
              <EditableFields
                key={id}
                rowClassName={cx(rowClassName, typeof getRowClassName === 'function' ? getRowClassName(updatedFieldsRow) : '')}
                columns={columns}
                fieldsRow={updatedFieldsRow}
                isRemovable={isRemovableRow}
                removeSize={removeSize}
                editSize={editSize}
                onRemove={() => this.handleRemove(id)}
                onEdit={fieldsRow[0].onEdit ? () => fieldsRow[0].onEdit(id) : null}
                getFields={() => {
                  const _fields = this.getResult(fieldValues)

                  return {
                    row: _fields[index],
                    fields: _fields,
                  }
                }}
              />
            )
          })
        }
        <div
          className={cx({
            [s.buttons]: addButtonTitle,
            [s.nextButton]: !addButtonTitle,
          })}
        >
          {
            Boolean(addButtonTitle) && (
              <Button
                className={s.button}
                title={addButtonTitle}
                greenInverted
                fullWidthOnMobile
                onClick={this.handleAdd}
              />
            )
          }
          {
            withButton && (
              <Button
                className={s.button}
                title={buttonTitle || 'Ок'}
                green
                fullWidthOnMobile
                onClick={submitForm(this.handleSubmit, this.handleSubmitError)}
              />
            )
          }
        </div>
      </div>
    )
  }
}


export default reduxForm(getFormOptions)(EditableTable)
